export enum FeaturesRoutingEnum {
  HelpForm = 'helps',
  Dashboard = 'dashboard',
  NotFound = '404',
  Cpu = 'cpu',
  Faq = 'faq',
  DepotForm = 'depot-form',
  Advices = 'advices',
  Authors = 'authors',
  Payment = 'payment',
  UpdateData = 'update-data',
  Banking = 'banking',
  TestAwin = 'test-awin',
  HelpsListing = 'aides',
  Help = 'aide',
  ValidateIban = 'validate-iban',
  PartnerRedirect = 'partner-redirect',
  DossierDetail = 'detail/:dossierId',
  StartComplementaryForm = 'start/:suggestionId',
  NpsFeedback = 'nps-feedback',
  Promise = 'promise',
  Chatbot = 'chatbot',
  Order = 'order',
  Partner = 'partner',
}
